import { AbstractIntlMessages, hasLocale } from "next-intl"
import { defineRouting } from "next-intl/routing"
import { getRequestConfig } from "next-intl/server"

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "cs"],
  // Used when no locale matches
  defaultLocale: "cs",
  localePrefix: "always",
})

export async function loadI18nMessages(locale: string) {
  return (await import(`./locales/${locale}.json`)).default as AbstractIntlMessages
}

export default getRequestConfig(async ({ requestLocale }) => {
  const requested = await requestLocale
  const locale = hasLocale(routing.locales, requested) ? requested : routing.defaultLocale
  return {
    locale,
    // relative path from this file
    messages: await loadI18nMessages(locale),
  }
})
